'use client';

import { LabelWithLinkMasking, type LabelLinkProps } from '../../../label';
import { IconMedia } from '../../../icons';
import { createFooterClickHandler } from '../../utils/clickHandler';
import type { LogoLinkListItemProps } from './types';
import { ICON_HEIGHTS } from '../../../../constants';

/**
 * Gets the specific icon height based on the title and icon.
 *
 * @param title - Link title
 * @param icon - Icon name
 * @returns Icon height
 */
function getIconHeight(title: string, icon: string) {
  if (title === 'MasterCard' || icon?.includes('download')) {
    return ICON_HEIGHTS.mastercard;
  }

  if (icon?.includes('appstore')) {
    return ICON_HEIGHTS.appstore;
  }

  return ICON_HEIGHTS.default;
}

/**
 * Creates an icon element based on the provided icon and title.
 *
 * @param icon - Icon name
 * @param title - Link title
 * @returns Icon element
 */
function createIcon(icon: string, title: string) {
  const height = getIconHeight(title, icon);

  return <IconMedia alt={title} icon={icon} height={height} color="dark" loading="lazy" rootMarginIntersection="500px" />;
}

/**
 * Creates a logo link element based on the provided props.
 *
 * @param props - Logo link props
 * @returns Logo link element
 */
export function LogoLink(props: LogoLinkListItemProps) {
  const labelLinksProps: LabelLinkProps = {
    icon: createIcon(props.icon, props.title),
    onClick: createFooterClickHandler(props),
    title: props.mouseOverText || props.title,
    href: props.url,
    masked: props.masked,
  };

  return <LabelWithLinkMasking {...labelLinksProps} />;
}
